import {useState,useEffect,useContext} from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Card,CardBody,CardHeader } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { ProyectosAprobado } from '../../interfaces/ProyectoAprobado';
import axios from 'axios';
import {HiOutlineDocumentSearch} from 'react-icons/hi';
import { CasUserContext, useCasUserContext } from '../../services/casUserContext'; 
import Checkbox from '@mui/material/Checkbox';
import { certificado } from '../../interfaces/Certificados';
import AlertService from '../../services/AlertService';
import CertificadoService from '../../services/CertificadoService';
import { Alert, AlertTitle, Button } from '@mui/material';
import CertificadosTable from './CertificadosTable';

const alertaService = new AlertService;
const certificadoService = new CertificadoService;



const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));
export default function MisCertificados(){
    //const casUserContext = useContext(CasUserContext);
    const casUserContext = useCasUserContext();
    let history = useNavigate()
    const token = casUserContext.token;
    const idusuarioInv = casUserContext.userData.idinv;
    let [certificadosProyecto,setCertificadoProyecto] = useState<Array<certificado>>([]);

    const fetchData = async () =>{
      try{
           alertaService.showLoading("Cargando Datos...");   
           certificadoService.GetCertificadosProyectoByIdInvestigador(idusuarioInv,token) 
           .then((data)=>{
            if(data.status.isSuccessfully){
              //console.log(data.listData);
              setCertificadoProyecto(data.listData);
            }
           })           
           .catch((error) => console.error(error));               
           alertaService.hideLoading();                
      }catch(error){
        console.error('Error:',error);
      }
    };

    useEffect(() => {
      fetchData();
    },[]);

    useEffect(() => {
      fetchData();
    },[token,idusuarioInv]);

    return (

        <Card>
      <CardHeader><strong>Certificados del Investigador</strong></CardHeader>
      <CardBody>
        <Alert severity="info">
            <AlertTitle>Info</AlertTitle>
                Estimado Investigador, para emitir un certificado de participación en proyectos de investigación, diríjase a la sección <a href='/SolicitarFirmaDec'>Generar certificado</a>.
        </Alert>
        <br />
        <CertificadosTable rowsPerPage={[5 ,10, 25, 100]} data={certificadosProyecto} />
      </CardBody>
   </Card>


    )
}